import ArticleList from "../ArticleList";
import React, { useState, useEffect, useRef, useCallback } from "react";
import agent from "../../agent";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import CategoryModal from "../CategoryModal";

import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { JobService } from "../../Network/services/JobService";
import { commonService } from "../../Network/services/commonService";
import ShareJob from "../ShareJob";
import { TruncatedText } from "../../utils/textTruncation";
import PlanChip from "../PlanChip";

export const sortByList = [
    {
        id: '1',
        label: 'Newly Posted jobs',
        value: 'newly_posted'
    },
    {
        id: '2',
        label: 'Oldest Posted jobs',
        value: 'oldest_posted'
    },
    {
        id: '3',
        label: 'Highest Price',
        value: 'highest_price'
    },
    {
        id: '4',
        label: 'Lowest Price',
        value: 'lowest_price'
    },
    {
        id: '5',
        label: 'Location (Nearest First)',
        value: 'location_nearest'
    },
    {
        id: '6',
        label: 'Most Applied',
        value: 'most_applied'
    },
    {
        id: '7',
        label: 'Nearest Target Date',
        value: 'nearest_target_date'
    },
    {
        id: '8',
        label: 'Longest Target Date',
        value: 'longest_target_date'
    },
    {
        id: '9',
        label: 'Relevant to me',
        value: 'relevant_to_me'
    }
];

const YourFeedTab = (props) => {
  if (props.token) {
    const clickHandler = (ev) => {
      ev.preventDefault();
      props.onTabClick("feed", agent.Articles.feed, agent.Articles.feed());
    };

    return (
      <li className="nav-item">
        <a
          href=""
          className={props.tab === "feed" ? "nav-link active" : "nav-link"}
          onClick={clickHandler}
        >
          Your Feed
        </a>
      </li>
    );
  }
  return null;
};

const GlobalFeedTab = (props) => {
  const clickHandler = (ev) => {
    ev.preventDefault();
    props.onTabClick("all", agent.Articles.all, agent.Articles.all());
  };
  return (
    <li className="nav-item">
      <a
        href=""
        className={props.tab === "all" ? "nav-link active" : "nav-link"}
        onClick={clickHandler}
      >
        Global Feed
      </a>
    </li>
  );
};

const TagFilterTab = (props) => {
  if (!props.tag) {
    return null;
  }

  return (
    <li className="nav-item">
      <a href="" className="nav-link active">
        <i className="ion-pound"></i> {props.tag}
      </a>
    </li>
  );
};

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MainView = (props) => {
  const [jobs, setJobs] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [allJobs, setAllJobs] = useState([]); // Store all jobs for search filtering
  const [openShareJob, setOpenSharejob] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showFullList, setShowFullList] = useState(false);
  const [listCount, setListCount] = useState(3);
  const [categoryView, setCategoryView] = useState(false);
  const [filterView, setFilterView] = useState(false);

  const [categoryData, setCategoryData] = useState([]);
  const [filteredcategoryData, setFilteredCategoryData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedfilterData, setSelectedfilterData] = useState("");
  const [selectedKeywordData, setSelectedKeywordData] = useState("");
  const [selectedSortData, setSelectedSortData] = useState("");
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoriesError, setCategoriesError] = useState(null);
  const [expandedParentCategory, setExpandedParentCategory] = useState("first");
  const [selectedChildCategory, setSelectedChildCategory] = useState(null);

  const [isChangePasswordModelOpen, setIsChangePasswordModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);  
  const [attachmentLink, setattachmentLink] = useState("");  
  const [filtype, sefiltype] = useState("");  

  const debounceTimeoutRef = useRef(null);
  const isInitialMountRef = useRef(true);
  

  const selectedSortDataRef = useRef(selectedSortData);
  const selectedfilterDataRef = useRef(selectedfilterData);
  const selectedCategoryRef = useRef(selectedCategory);
  
  useEffect(() => {
    selectedSortDataRef.current = selectedSortData;
  }, [selectedSortData]);
  
  useEffect(() => {
    selectedfilterDataRef.current = selectedfilterData;
  }, [selectedfilterData]);
  
  useEffect(() => {
    selectedCategoryRef.current = selectedCategory;
  }, [selectedCategory]);
  
  const debouncedSearch = useCallback((searchTerm) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      fetchjobcall(
        selectedSortDataRef.current, 
        selectedfilterDataRef.current, 
        selectedCategoryRef.current, 
        searchTerm || ""
      );
    }, 800); 
  }, []); 

  useEffect(() => {
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
      return;
    }
    debouncedSearch(filterValue);
    
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [filterValue, debouncedSearch]);

  let openChangePasswordmodel = (aLink) => {
    let fileExt =  aLink.split(/[#?]/)[0].split('.').pop().trim();

    let ext = fileExt.toLowerCase();

    if (ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'bmp' || ext == 'png') {
      sefiltype('image')
    }
    else {
      sefiltype('others')
    }

    setattachmentLink(aLink);
    setIsChangePasswordModelOpen(true);
  };
  let closeChangePasswordmodel = () => {
    setIsChangePasswordModelOpen(false);
  };


  let getFileType = (aLink) => {
    let fileExt =  aLink.split(/[#?]/)[0].split('.').pop().trim();
    let ext = fileExt.toLowerCase();

    if (ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'bmp' || ext == 'png') {
      return "image";
    }
    else {
      return "others";
    }
  };

  const fetchCategories = async () => {
    setCategoriesLoading(true);
    setCategoriesError(null);
    
    try {
      const categoriesData = localStorage.getItem('categories_with_sub_categories');
      
      if (categoriesData) {
        const parsedData = JSON.parse(categoriesData);
        
        if (parsedData && Array.isArray(parsedData)) {
          const parentCategories = parsedData
            .filter(parent => 
              parent.status !== 'Deactive' && 
              parent.fws_categories && 
              parent.fws_categories.length > 0
            )
            .map(parent => ({
              ...parent,
              fws_categories: parent.fws_categories
                .filter(child => child.status !== 'Deactive')
                .sort((a, b) => 
                  a.category_name.localeCompare(b.category_name)
                )
            }))
            .filter(parent => parent.fws_categories.length > 0)
            .sort((a, b) => a.parent_category_name.localeCompare(b.parent_category_name));
          
          setCategoryData(parentCategories);
          setFilteredCategoryData(parentCategories);
          
          if (parentCategories.length > 0) {
            setExpandedParentCategory(parentCategories[0].id);
          }
        } else {
          setCategoriesError("categories data not found");
         
        }
      } else {
        setCategoriesError("No categories data found in localStorage");
      
      }
    } catch (error) {
      console.error("Error loading categories from localStorage:", error);
      setCategoriesError("Error loading categories. Please try again.");
   
    
    } finally {
      setCategoriesLoading(false);
    }
  };

  const toggleAccordion = (parentCategoryId) => {
    if (expandedParentCategory === parentCategoryId) {
      setExpandedParentCategory(null); 
    } else {
      setExpandedParentCategory(parentCategoryId); 
    }
  };

  const handleChildCategorySelect = (parentCategoryName, childCategoryName) => {
    setSelectedChildCategory(childCategoryName);
    setSelectedCategory(childCategoryName);
    
    explore_jobs(parentCategoryName, childCategoryName);
  };

  const explore_jobs = (category, value) => {
    setCategoryView(false);
    const searchTerm = filterValue || "";
    fetchjobcall(selectedSortData, selectedfilterData, value, searchTerm);
  };


  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    
    if(JSON.parse(window.localStorage.getItem("isLoggedIn")))
    {
      fetchjobcall(selectedSortData, selectedfilterData, selectedCategory, selectedKeywordData)
    }
    
     setTimeout(() => {
        fetchCategories();
    }, 1200);

    
  }, []);

  useEffect(() => {
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const toggleModel = (job = null) => {
    setSelectedJob(job);
    setOpenSharejob(prevCheck => !prevCheck);
  }
  const fetchjobcall = (sort, filter, category, keyword = "") => {
    if (!isMountedRef.current) {
      return;
    }
    
    setLoading(true)
    const form = new FormData();
    form.append('sort',sort);
    form.append('location_filter',filter);
    form.append('category',category);
    form.append('search',keyword);
    
    
    JobService.getJobs(form)
      .then(async (res) => {
       
        if (res && res.status == 200) {
            setJobs(res.data); 
            setAllJobs(res.data);
        } else {
          setJobs([]);
          setAllJobs([]);
        }
      })
      .catch((err) => {
        console.error('Job fetch error details:', {
          message: err.message,
          name: err.name,
          code: err.code,
          stack: err.stack,
          config: err.config
        });
      })
      .finally(() => {
        if (isMountedRef.current) {
          setLoading(false)
        }
      });
  };

  return (
    <section className="post">
      <div className="container">
        <div className="post-filter">
          <div className="row">
            <div className="w-100 d-flex responsive-justify">
              <div className="search-container" style={{width: '100%','max-width': 'none'}}>
                <div className="search-input-wrapper">
                  <img src="assets/images/SearchIcon.svg" alt="Search" className="search-icon" />
                  <input
                    type="text"
                    placeholder="Search jobs..."
                    value={filterValue}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setFilterValue(newValue);
                    }}
                  />
                </div>
              </div>
              <ul >
                <li className="sort-dropdown-container">
                  <a href="#" className="sort-trigger">
                     <span>Sort by</span>
                  </a>
                  <ul className="sort-dropdown-menu">
                    {sortByList.map((sortOption) => (
                      <li key={sortOption.id}>
                        <label>
                          <input 
                            type="radio" 
                            name="sort" 
                            value={sortOption.value} 
                            onChange={event => {
                              setSelectedSortData(event.target.value);
                              const searchTerm = filterValue || selectedKeywordData || "";
                              fetchjobcall(event.target.value, selectedfilterData, selectedCategory, searchTerm);
                            }} 
                          />
                          {sortOption.label}
                        </label>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                <a href="#" onClick={(e)=>{
                    e.preventDefault();
                    setFilterView(true)
                  }}>
                     <span>Filter</span>
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e)=>{
                    e.preventDefault();
                    setCategoryView(true)
                  }}>
                    <span>Category</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
          <LoadingOverlay>

            {!loading && jobs.length === 0 ? (
              <div className="no-jobs-message" style={{
                textAlign: 'center',
                padding: '60px 20px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                margin: '20px 0'
              }}>
                <div style={{
                  fontSize: '48px',
                  marginBottom: '20px',
                  opacity: '0.5'
                }}>
                  📋
                </div>
                <h3 style={{
                  color: '#6c757d',
                  marginBottom: '10px',
                  fontWeight: '500'
                }}>
                  No Jobs Found
                </h3>
                <p style={{
                  color: '#848484',
                  fontSize: '16px',
                  margin: '0'
                }}>
                  There are currently no jobs available. Check back later for new opportunities!
                </p>
              </div>
            ) : (
              jobs.slice(0,listCount).map((job) => (
                <div key={job.id} className="post-list">
                  <Link style={{width: "100%"}} to={{ pathname: `/job/${job.id}/`, state: { job } }}>
                    <div className="plan-meta-row">
                      <div className="plan-chip-container">
                        {job.job_plan && <PlanChip jobPlan={job.job_plan} />}
                      </div>
                      <div className="job-meta">
                        <span className="job-id">Job ID: {job.job_unique_id?.replace('Job# ', '') || job.id}</span>
                        <span className="job-location">• <TruncatedText text={job.job_location} maxLength={50} /></span>
                        <span className="share-icon" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedJob(job); setOpenSharejob(true); }}><img src="/assets/images/ShareIcon.svg" /></span>
                      </div>
                    </div>

                    <div className="category-skills-row">
                      <div className="job-category">
                        {job.parent_category_name && job.category_full_name 
                          ? `${job.parent_category_name} > ${job.category_full_name}`
                          : job.category_full_name || job.category || 'General'}
                      </div>
                      {job.skills && (
                        <div className="job-title-skills">
                          {job.skills.split(',').map((skill, index) => (
                            <span key={index} className="skill-tag">
                              {skill.trim()}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>

                    <h1 className="job-title">
                      <TruncatedText 
                        text={job.job_title} 
                        maxLength={50} 
                        className="job-title-text" 
                      />
                    </h1>

                  

                    <div className="payment-info">
                      <div className="payment-amount">
                        ₹{job.amount}
                      </div>
                      <div className="payment-details">
                        {job.payment_term} | {job.timestamp} {job.is_own_job == "1" && "| You Posted"}
                      </div>
                    </div>


                    <div className="job-footer">
                      <div className="target-date">
                        Target Close Date: {job.target_closed_date}
                      </div>
                      <div className="quotes-count">
                        {job.total_quotes_received || 0} Quotes received
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
              <Loader loading={loading} />
                </LoadingOverlay>
            {showFullList?null:jobs.length>3?
            <div className="row">
              <div className="col-md-12 text-center">
                <a href="#"  className="view-all-jobs" onClick={(e)=>{
                  e.preventDefault();
                  setShowFullList(true);
                  setListCount(jobs.length)
                }}>
                  View all Jobs
                </a>
              </div>
            </div>:null}
          </div>
        </div>
      </div>
      
      <Modal
        isOpen={isChangePasswordModelOpen}
        onRequestClose={closeChangePasswordmodel}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
          <LoadingOverlay>
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content" onClick={(e)=>{e.preventDefault()}}>
              <div className="dashboard signin">
                <div className="modal-header">
                  <h5 className="modal-title">Attachment</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeChangePasswordmodel} >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body" style={{paddingBottom: '30px'}}>
                 
                  {filtype == "image" ? 
                    <div style={{textAlign:"center"}}>
                      <img  src={attachmentLink} />
                    </div>
                  :  
                    <Link to={attachmentLink} target="_blank" download>Open or Download</Link> 
                  }
                </div>
              </div>

            </div>
          </div>
          <Loader loading={loading} />
          </LoadingOverlay>
      </Modal>

      <Modal
        isOpen={filterView}
        onRequestClose={() => {
          setFilterView(false);
          document.body.classList.remove('modal-open');
        }}
        onAfterOpen={() => {
          document.body.classList.add('modal-open');
          setSelectedfilterData("");
          setSelectedKeywordData("");
        }}
        style={filterModalStyles}
        contentLabel="Filters Modal"
        scrollable={true}
      >
        <div className="filters-modal">
          <div className="filters-modal-header">
            <h5 className="filters-modal-title">Filters</h5>
            <button type="button" className="filters-close-btn" onClick={() => {
              setFilterView(false);
              document.body.classList.remove('modal-open');
            }}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="filters-modal-body">
            <div className="filter-input-group">
              <label className="filter-label">Search by location</label>
              <input 
                type="text" 
                placeholder="Eg: Bengaluru" 
                className="filter-input" 
                onChange={(e) => setSelectedfilterData(e.target.value)}
              />
            </div>
            <div className="filter-input-group">
              <label className="filter-label">Search by keyword</label>
              <input 
                type="text" 
                placeholder="Eg: Electrician" 
                className="filter-input" 
                onChange={(e) => setSelectedKeywordData(e.target.value)}
              />
            </div>
            <button 
              type="submit" 
              className="apply-filter-btn" 
              onClick={() => {
                setFilterView(false)
                document.body.classList.remove('modal-open')
                const searchTerm = filterValue || selectedKeywordData || "";
                fetchjobcall(selectedSortData, selectedfilterData, selectedCategory, searchTerm)
              }}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </Modal>

      {/* CategoryModal: Modal component for selecting job categories with parent and child category hierarchy */}
      <CategoryModal
        isOpen={categoryView}
        onClose={() => setCategoryView(false)}
        categoryData={categoryData}
        filteredCategoryData={filteredcategoryData}
        selectedChildCategory={selectedChildCategory}
        expandedParentCategory={expandedParentCategory}
        onToggleAccordion={toggleAccordion}
        onSelectCategory={handleChildCategorySelect}
        loading={categoriesLoading}
        error={categoriesError}
        modalStyles={customStyles}
      />
      <ShareJob 
        isOpen={openShareJob} 
        toggle={() => toggleModel()} 
        jobData={selectedJob}
      />
    </section>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    height: "auto",
    maxHeight: "90vh",
    background: "transparent",
    border: "none",
    padding: "0",
    overflow: "auto",
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

const filterModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "500px",
    height: "auto",
    maxHeight: "90vh",
    background: "transparent",
    border: "none",
    padding: "0",
    overflow: "auto",
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(MainView);
